import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { BannerSlot, BannerSuggestions } from '@core/tellent-assistant-types';

type BannerSuggestionsEntry = BannerSuggestions & { id: string };

const idSelector = (entry: BannerSuggestionsEntry) => entry.id;

const { selectors, reducer, actions, namespace } =
  createEntityCollectionStore<BannerSuggestionsEntry>()('TellentAssistantSuggestions', {
    idSelector,
    customActions: adapter => ({
      fetchOne: (state, payload: { id: string; slot: BannerSlot }) =>
        adapter.markAsPending(state, { scope: null, entities: [payload.id] }),
    }),
  });

export {
  selectors as TellentAssistantSuggestionsSelectors,
  reducer as TellentAssistantSuggestionsReducer,
  actions as TellentAssistantSuggestionsActions,
  namespace as TellentAssistantSuggestionsNamespace,
};
